import React from 'react';

export default {
	path: '/faq',
	components: () => [import('./component')],
	render: ([Faq]) => <Faq />,
};
